
import './index.less'
import React from 'react'

import { useState, useEffect } from 'react'
console.log(React)
export default function NavItem(props) {
  const [ifon, setIfon] = useState({
    isPress: false
  })

  useEffect(() => {
    const up = (event) => {
      if (ifon.isPress && props.isCut) {
        setIfon({
          ...ifon,
          isPress: false
        })
      }
    }

    window.addEventListener('mouseup', up)

    return () => {
      window.removeEventListener('mouseup', up)
    }
  })

  return (
    <div className={`navItem ${(ifon.isPress && props.isCut) ? 'press' : ''} ${!props.isCut ? 'jinyon' : ''}`} onMouseDown={() => {
      setIfon({ isPress: true })
    }}>
      {props.icon && <i className='navItem_icon'>{props.icon}</i>}
      {props.text && <span className='navItem_text'>{props.text}</span>}
    </div>
  )
}
